module.exports = __webpack_public_path__ + "static/media/rilska_prepravka_korica.aaea3a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/rilska_prepravka_korica.png
// module id = 186
// module chunks = 0